<template>
  <div>
    <div class="card">
      <div class="card-header py-2">
        <b-form-checkbox class="display-inline marginright5" v-model="checkedAll" :indeterminate="indeterminate">
        </b-form-checkbox>
        <span @click="checkedAll = !checkedAll">{{ $t(placeTypeGroup.name) }}</span>
        <!--<button v-if="($store.state.user) && (window.isDesktop)" class="btn btn-primary btn-sm" @click="openNewPlaceModal(true, null)">{{ $t('addPlace') }}</button>-->
        <div style="float: right;">
          <b-form-checkbox class="display-inline marginright5" v-model="showApproved"></b-form-checkbox>
          <span @click="showApproved = !showApproved"><img style="width: 16px; height: 16px; margin-right: 20px" :src="icons.approved"></span>
          <b-form-checkbox class="display-inline marginright5" v-model="showNotApproved"></b-form-checkbox>
          <span @click="showNotApproved = !showNotApproved"><img style="width: 16px; height: 16px; margin-right: 20px" :src="icons.question"></span>
          <img @click="togglePanel" style="height: 13px; cursor: pointer;" :src="iconsVisible ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div v-show="iconsVisible" ref="places" class="card-body p-2">
        <div v-for="placeType of placeTypeGroup.placeGroups" :key="placeType.name">
          <div :style="{'margin-bottom': window.isDesktop ? 0 : '15px'}">
            <b-form-checkbox class="display-inline marginright5" style="margin-right: 5px" v-model="placeType.checked" @change="onPlaceGroupsChanged($event, placeType.id)"></b-form-checkbox>
            <span @click="placeType.checked = !placeType.checked; onPlaceGroupsChanged(null, placeType.id)"><img style="width: 16px; height: 16px;" :src="markerIcons[placeType.icon.replaceAll('-', '_')]" />
            {{ $t(placeType.name) }}</span>
          </div>  
        </div>
      </div>
    </div>
    <br>
  </div>  
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import $ from 'jquery';
import { EventBus } from '@/ts/EventBus';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        const iconsVisible: boolean = true;
        const checkedAll: Boolean = false;

        return {
            checkedAll,
            iconsVisible,
            showApproved: true,
            showNotApproved: true
        };
    },
    computed: {
        allChecked() {
            let oneChecked = false;
            let oneUnChecked = false;
            for (const placeGroup in this.placeTypeGroup.placeGroups) {
              if (this.placeTypeGroup.placeGroups[placeGroup].checked) {
                oneChecked = true;
              } else {
                oneUnChecked = true;
              }
            }
            if (oneChecked && !oneUnChecked) {
              return true;
            }
        },
        allUnChecked() {
            let oneChecked = false;
            let oneUnChecked = false;
            for (const placeGroup in this.placeTypeGroup.placeGroups) {
              if (this.placeTypeGroup.placeGroups[placeGroup].checked) {
                oneChecked = true;
              } else {
                oneUnChecked = true;
              }
            }
            if (!oneChecked && oneUnChecked) {
              return true;
            }
        },
        indeterminate() {
            let oneChecked = false;
            let oneUnChecked = false;
            for (const placeGroup in this.placeTypeGroup.placeGroups) {
              if (this.placeTypeGroup.placeGroups[placeGroup].checked) {
                oneChecked = true;
              } else {
                oneUnChecked = true;
              }
            }
            return oneChecked && oneUnChecked;
        }
    },
    mounted() {
      EventBus.$on('togglePlaceTypeGroup_' + this.placeTypeGroup.name, () => {
        this.checkedAll = !this.checkedAll;
      });
    },
    methods: {
        onPlaceGroupsChanged(event: boolean, id: number) {
            for (const placeGroup in this.placeTypeGroup.placeGroups) {
              this.showOrHidePlaces(this.placeTypeGroup.placeGroups[placeGroup].id)
            }
        },
        showOrHidePlaces(groupId: number) {
            for (const place of this.placeTypeGroup.placeGroups[groupId].places) {
              if ((this.placeTypeGroup.placeGroups[groupId].checked) && (((place.approved) && (this.showApproved)) || ((!place.approved) && (this.showNotApproved)))) {
                place.getMarker().addTo(window.mainmap)
              } else {
                place.getMarker().removeFrom(window.mainmap)
              }
            }
        },
        togglePanel() {
            //$(this.$refs.places).slideToggle('slow');
            this.iconsVisible = !this.iconsVisible;
        },
        openNewPlaceModal() {
            EventBus.$emit('NewPlaceRequested', true, null);
        },
        onCheckedAllChanged(value: boolean, oldValue: boolean) {
            for (const placeGroup in this.placeTypeGroup.placeGroups) {
              this.placeTypeGroup.placeGroups[placeGroup].checked = this.checkedAll;
              this.showOrHidePlaces(this.placeTypeGroup.placeGroups[placeGroup].id)
            }
        },
        onallCheckedChanged(value: boolean, oldValue: boolean) {
            if (this.allChecked) {
              this.checkedAll = true;
            }
        },
        onallUnCheckedChanged(value: boolean, oldValue: boolean) {
            if (this.allUnChecked) {
              this.checkedAll = false;
            }
        },
        refreshApproved() {
            for (const placeGroup in this.placeTypeGroup.placeGroups) {
              this.showOrHidePlaces(this.placeTypeGroup.placeGroups[placeGroup].id)
            }
        },
        refreshNotApproved() {
            for (const placeGroup in this.placeTypeGroup.placeGroups) {
              this.showOrHidePlaces(this.placeTypeGroup.placeGroups[placeGroup].id)
            }
        },
        showOrHideAllPlaces() {
            for (const placeGroup in this.placeTypeGroup.placeGroups) {
              this.showOrHidePlaces(this.placeTypeGroup.placeGroups[placeGroup].id);
            }
        }
    },
    props: {
        placeTypeGroup: { required: false,
            type: Object as PropType<any>
        },
        refresh: { required: false,
            type: Number
        }
    },
    watch: {
        "checkedAll": [{
            handler: "onCheckedAllChanged"
        }],
        "allChecked": [{
            handler: "onallCheckedChanged"
        }],
        "allUnChecked": [{
            handler: "onallUnCheckedChanged"
        }],
        "showApproved": [{
            handler: "refreshApproved"
        }],
        "showNotApproved": [{
            handler: "refreshNotApproved"
        }],
        "refresh": [{
            handler: "showOrHideAllPlaces"
        }]
    }
})


</script>